export default __webpack_public_path__ + "static/media/User-Warning.fc11f889.svg";